export * from "@apollo/client-integration-nextjs";
